import script from "./cashbackHistoryPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./cashbackHistoryPopup.vue?vue&type=script&setup=true&lang=ts"

import "./cashbackHistoryPopup.vue?vue&type=style&index=0&id=9a5e3610&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a5e3610"]])

export default __exports__